// Copyright (C) 2017-2023 Smart code 203358507

const ColorPicker = require('./ColorPicker');

module.exports = ColorPicker;
